// LimitModal.jsx – Hinweisfenster, wenn eine Änderung die Grenzen des Stammbaums
// überschreiten würde (mehr als 4 Generationen oder zu viele Personen ganz oben).
// Die Grenzen selbst werden in utils/treeRules.js geprüft.
import React from 'react';
import './Modal.css';

// Titel und Text je nach Grund ('generations' oder 'topGeneration').
const TEXTS = {
  generations: {
    title: 'Generationslimit erreicht',
    body:  <>Zurzeit werden beim <strong>Stammbaum-Memo</strong> nur 4 Generationen unterstützt.</>,
  },
  siblingNoParents: {
    title: 'Zuerst die Eltern eintragen',
    body:  <>Geschwister kann man nur bei Personen eintragen, deren <strong>Eltern schon im Stammbaum</strong> sind – Geschwister hängen an den gemeinsamen Eltern. Trage zuerst die Eltern ein. Bei eingeheirateten Partnern ab der dritten Generation geht das nicht; ihre Familie kannst du als <strong>Erweiterung</strong> erfassen.</>,
  },
  partnerParents: {
    title: 'Hier sind keine Eltern möglich',
    body:  <>Partner und Expartner ab der dritten Generation (z.B. der Partner eines Enkelkindes) können beim <strong>Stammbaum-Memo</strong> keine Eltern bekommen – ihre Familie lässt sich mit Farben und Symbolen nicht mehr eindeutig darstellen. Ihre Familie kannst du aber als <strong>Erweiterung</strong> erfassen: im Dashboard unter „Erweiterung zu einem Stammbaum erstellen“.</>,
  },
  topGeneration: {
    title: 'Oberste Generation ist voll',
    body:  <>In der obersten Generation sind beim <strong>Stammbaum-Memo</strong> höchstens 2 Einheiten möglich – also 2 Paare, 2 Einzelpersonen oder ein Paar und eine Einzelperson (z.B. beide Grosseltern-Paare).</>,
  },
};

export function LimitModal({ reason = 'generations', onClose }) {
  const t = TEXTS[reason] || TEXTS.generations;
  return (
    // Klick auf den grauen Hintergrund schliesst das Fenster; stopPropagation verhindert,
    // dass ein Klick im Fenster selbst ebenfalls schliesst. (Gleiches Muster in allen Fenstern.)
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ padding: '32px 28px', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 14, fontSize: 20, color: '#1a1a1a' }}>{t.title}</h2>
        <p style={{ color: '#333', lineHeight: 1.7, marginBottom: 14, fontSize: 15 }}>
          {t.body}
        </p>
        <p style={{ color: '#333', lineHeight: 1.7, marginBottom: 28, fontSize: 15 }}>
          Falls mehr gewünscht ist, melde dich bitte direkt bei{' '}
          <a href="mailto:stammbaum-memo@bandeleart.ch" style={{ color: '#1540dc' }}>
            stammbaum-memo@bandeleart.ch
          </a>.
        </p>
        <button className="btn btn--primary" onClick={onClose} style={{ width: '100%', fontSize: 15, padding: '12px 0', borderRadius: '8px' }}>
          Verstanden
        </button>
      </div>
    </div>
  );
}
